<template>
  <div id="app" class="min-h-screen w-screen bg-slate-600">
    <router-view />
  </div>
  
</template>
<script>
  export default {
    watch: {
      // Set meta tags
      $route(to) {
        this.setMeta(to.meta);
      },
    },
    methods: {
      setMeta(meta) {
        document.title = meta.pageTitle;
        if(meta.title === undefined)
        {
          document.title = 'WBtank - klient';
        }
      }
    }
  }
</script>
<style>

body
{
  overflow-x: hidden;
}

</style>

